import React from 'react';
import { getColorCode, getSwatchBackgroundStyle, parseColorValue } from './ColorMap';

const cardSwatchButtonStyle = {
  width: '20px',
  height: '20px',
  cursor: 'pointer',
  position: 'relative',
  borderRadius: '50%',
  transition: 'transform 0.3s',
  border: '1px solid #ccc',
  padding: 0,
  overflow: 'hidden',
};

export default function ColorSwatch({
  color,
  onClick,
  variant = 'card',
  style = {},
  className = '',
  active = false,
  tooltipStyle,
  ...rest
}) {
  const { label, isDual } = parseColorValue(color);
  const swatchStyle = getSwatchBackgroundStyle(color);

  if (variant === 'product') {
    return (
      <button
        type="button"
        style={{ marginRight: '5px', ...style }}
        className={`color tp-color-variation-btn${active ? ' active' : ''}${className ? ` ${className}` : ''}`}
        onClick={onClick}
        aria-label={`Select color: ${label}`}
        {...rest}
      >
        <span
          className="tp-color-swatch"
          data-bg-color={!isDual ? getColorCode(parseColorValue(color).parts[0]) : 'dual'}
          style={{ border: '1px solid #ccc', ...swatchStyle }}
        />
        <span className="tp-color-variation-tootltip">{label}</span>
      </button>
    );
  }

  if (variant === 'filter') {
    return (
      <span
        className={`tp-shop-widget-checkbox-circle-self tp-color-swatch${className ? ` ${className}` : ''}`}
        data-bg-color={!isDual ? getColorCode(parseColorValue(color).parts[0]) : 'dual'}
        style={{ border: '1px solid #ccc', ...swatchStyle, ...style }}
        {...rest}
      />
    );
  }

  return (
    <button
      type="button"
      style={{ ...cardSwatchButtonStyle, ...swatchStyle, ...style }}
      onClick={onClick}
      aria-label={`Select color: ${label}`}
      {...rest}
    >
      {tooltipStyle ? <span style={tooltipStyle}>{label}</span> : null}
    </button>
  );
}
